import { useState, useCallback, useEffect } from 'react';

const keyFor = (userId: string | undefined) => `warehouse-pinned-items:${userId ?? 'anon'}`;

function read(userId: string | undefined): string[] {
  try {
    const raw = localStorage.getItem(keyFor(userId));
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter((x): x is string => typeof x === 'string') : [];
  } catch {
    return [];
  }
}

export function usePinnedWarehouseItems(userId: string | undefined) {
  const [pinned, setPinned] = useState<string[]>(() => read(userId));

  useEffect(() => { setPinned(read(userId)); }, [userId]);

  const togglePin = useCallback((id: string) => {
    setPinned(prev => {
      const next = prev.includes(id) ? prev.filter(p => p !== id) : [...prev, id];
      try { localStorage.setItem(keyFor(userId), JSON.stringify(next)); } catch { /* memoria del browser non disponibile */ }
      return next;
    });
  }, [userId]);

  return { pinned, togglePin };
}
